import React, { useState } from 'react';

import SharedIncomeCalculatorBusiness from './shared-income-calculator-business';
import SharedIncomeCalculatorDefault from './shared-income-calculator-default';
import { Button, Heading } from '@chakra-ui/react';
import SharedIncomeCalculatorBusinessForm from './shared-income-calculator-business-form';
//import { assetsBaseUrl } from '../../services/calculationsApi';

// Define the type for the props
interface IncomeCalculatorModalProps {
  toggleIncomeCalculator: (value: string) => void;
}

const SharedIncomeCalculator: React.FC<IncomeCalculatorModalProps> = ({
  toggleIncomeCalculator
}) => {
  const [defaultCalculator, setDefaultCalculator] = useState(true);
  const [lastStepOpened, setLastStepOpened] = useState(false);

  const toggleLastStep = () => {
    setLastStepOpened(!lastStepOpened);
  };

  return (
    <div>
      <div className={`p-8`}>
        <Heading as={`h1`} variant={`h1`} mb={6}>
          {!lastStepOpened ? `Jaarinkomen berekenen` : `Benodigde gegevens`}
        </Heading>

        <div className={`my-4`}>
          {!lastStepOpened
            ? `Ik ben`
            : `Heb je aangiftes inkomstenbelasting en je jaarcijfers bij de hand? Vul de gegevens in die van toepassing zijn. Dit kan betekenen dat je niet alles hoeft in te vullen.`}
        </div>
        {!lastStepOpened && (
          <div className={`mb-8 md:mb-16`}>
            <Button
              onClick={() => setDefaultCalculator(true)}
              colorScheme={defaultCalculator ? `blue` : 'gray'}
              mr={4}
              isDisabled={false}>
              In loondienst
            </Button>

            <Button
              onClick={() => setDefaultCalculator(false)}
              colorScheme={!defaultCalculator ? `blue` : 'gray'}
              isDisabled={false}>
              Ondernemer/ZZP'er
            </Button>
          </div>
        )}

        {defaultCalculator ? (
          <SharedIncomeCalculatorDefault toggleIncomeCalculator={toggleIncomeCalculator} />
        ) : (
          <>
            {!lastStepOpened ? (
              <SharedIncomeCalculatorBusiness
                toggleIncomeCalculator={toggleIncomeCalculator}
                toggleLastStep={toggleLastStep}
              />
            ) : (
              <SharedIncomeCalculatorBusinessForm
                toggleIncomeCalculator={toggleIncomeCalculator}
                toggleLastStep={toggleLastStep}></SharedIncomeCalculatorBusinessForm>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SharedIncomeCalculator;
